import {iMultiUserDetails} from "@customTypes/appDataTypes/UserTypes";

import userData from "./user-data.json";

const multiUserProfile = userData as iMultiUserDetails;

export default multiUserProfile;
